import React from 'react';
import { Col, Row, Form, Input } from 'antd';

const { Item } = Form;

const Company = () => {
  return (
    <Row span={24}>
      <Col xs={8} md={4}>
        <h4>Company</h4>
      </Col>
      <Col xs={24} md={20}>
        <Item name="company">
          <Input
            size="large"
            name="company"
            style={{ borderRadius: 8 }}
            placeholder="Your Company Name"
          />
        </Item>
      </Col>
    </Row>
  );
};

export default Company;
